import { reportError } from "./libs/errorReporting"

// Start reporting before evaluating React, the app, or any optional integrations.
import("./bootstrap").catch((error) => {
	reportError(error, "Application startup")
	const screen = document.getElementById("startup-screen")
	if (screen) screen.setAttribute("role", "alert")
	const heading = document.getElementById("startup-heading")
	const message = document.getElementById("startup-message")
	if (heading) heading.textContent = "BusStock couldn’t load"
	if (message) message.textContent = "Please reload the page. If this continues, try another network or contact support@busstock.app."
})
